import { differenceInCalendarDays } from 'date-fns';

import { getTimeFromDate, setTimeToDate } from 'shared/helpers';

type TimeSlotVisibilityArgs = {
	intervalInMinutes?: number;
	minSelectableDate?: Date;
	selectedDate?: Date | null;
	slotTime: Date;
	now?: Date;
};

export const isSameCalendarDay = (dateA?: Date | null, dateB?: Date | null) =>
	Boolean(dateA && dateB && differenceInCalendarDays(dateA, dateB) === 0);

const isBeforeCalendarDay = (dateA: Date, dateB: Date) => differenceInCalendarDays(dateA, dateB) < 0;

const floorToInterval = (value: Date, intervalInMinutes: number) => {
	const flooredValue = new Date(value);
	const flooredMinutes = Math.floor(flooredValue.getMinutes() / intervalInMinutes) * intervalInMinutes;

	flooredValue.setMinutes(flooredMinutes, 0, 0);

	return flooredValue;
};

export const getDatePickerChangeValue = (date: Date, minSelectableDate?: Date) => {
	if (!minSelectableDate || date.getTime() >= minSelectableDate.getTime()) {
		return date;
	}

	const dateWithMinimumDay = setTimeToDate(getTimeFromDate(date), minSelectableDate);

	return dateWithMinimumDay.getTime() < minSelectableDate.getTime() ? minSelectableDate : dateWithMinimumDay;
};

export const shouldShowTimeSlot = ({
	intervalInMinutes = 15,
	minSelectableDate,
	selectedDate,
	slotTime,
	now = new Date(),
}: TimeSlotVisibilityArgs) => {
	const effectiveSelectedDate = selectedDate || minSelectableDate || now;
	const lowerBoundary = minSelectableDate || now;

	if (isBeforeCalendarDay(effectiveSelectedDate, lowerBoundary)) {
		return false;
	}

	if (!isSameCalendarDay(effectiveSelectedDate, lowerBoundary)) {
		return true;
	}

	return (
		setTimeToDate(getTimeFromDate(slotTime), effectiveSelectedDate).getTime() >=
		floorToInterval(lowerBoundary, intervalInMinutes).getTime()
	);
};
